import Immutable from 'immutable';
import { ActionTypes } from './actions';
export const initialState = Immutable.fromJS({});

const setAll = (state, { allShift }) => {
  if (!allShift) return state;
  return state.merge({ allShift });
};

const setIsDisabled = (state, { rowId, isDisabled }) => {
  return state.merge({ rowId, isDisabled });
};

const setLoader = (state, { showLoader }) => {
  return state.merge({ showLoader });
};

const setFactoryShifts = (state, { factoryShifts }) => {
  return state.merge({ factoryShifts });
};

const setFactoryShiftByTimeRange = (state, { factoryShift }) => {
  return state.merge({ factoryShift });
};

const setEquipmentShift = (state, { equipmentShift }) => {
  return state.merge({ equipmentShift });
};
const setEquipmentShiftById = (state, { equipmentShiftById }) => {
  return state.merge({ equipmentShiftById });
};
const setLoaderEquipmentShift = (state, { showEquipmentShiftLoader }) => {
  return state.merge({ showEquipmentShiftLoader });
};
const setJobEquipmentShiftsByJobId = (state, { jobEquipmentShiftsData }) => {
  return state.merge({ jobEquipmentShiftsData });
};
const setLineJobEquipmentShiftsByLineJobId = (state, { lineJobEquipmentShiftsData }) => {
  return state.merge({ lineJobEquipmentShiftsData });
};

const setFactoryCurrentShiftByFactoryId = (state, { factoryCurrentShift }) => {
  return state.merge({ factoryCurrentShift });
};

export const callbacks = [
  {
    actionType: ActionTypes.SET_ALL,
    actionFunction: setAll,
  },
  {
    actionType: ActionTypes.SET_IS_DISABLED,
    actionFunction: setIsDisabled,
  },
  {
    actionType: ActionTypes.SET_LOADER_STATUS,
    actionFunction: setLoader,
  },
  {
    actionType: ActionTypes.SET_SHIFTS_BY_FACTORY_ID,
    actionFunction: setFactoryShifts,
  },
  {
    actionType: ActionTypes.SET_FACTORY_SHIFT_BY_TIME_RANGE,
    actionFunction: setFactoryShiftByTimeRange,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_SHIFT,
    actionFunction: setEquipmentShift,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_SHIFT_BY_ID,
    actionFunction: setEquipmentShiftById,
  },
  {
    actionType: ActionTypes.SET_EQUIPMENT_SHIFT_LOADER,
    actionFunction: setLoaderEquipmentShift,
  },
  {
    actionType: ActionTypes.SET_CURRENT_SHIFT_BY_EQUIPMENT_ID,
    actionFunction: setJobEquipmentShiftsByJobId,
  },
  {
    actionType: ActionTypes.SET_JOB_SHIFTS_BY_LINE_JOB_ID,
    actionFunction: setLineJobEquipmentShiftsByLineJobId,
  },
  {
    actionType: ActionTypes.SET_FACTORY_CURRENT_SHIFT_BY_FACTORY_ID,
    actionFunction: setFactoryCurrentShiftByFactoryId,
  },
];
